import React from 'react';

const LoopMarking = ({ loopData, getMarkingPosition, y1, settings }) => {
  const x = getMarkingPosition(loopData.position, false); // Sempre da testa
  const textWidth = Math.max(loopData.content.length * 6, 25);

  return (
    <g className="loop-marking">
      <rect
        x={x - textWidth / 2} y={y1 - 8}
        width={textWidth} height={16}
        rx={3}
        fill="#FEF3C7" // Giallo chiaro per distinguere dalle altre marcature
        stroke="#F59E0B"
        strokeWidth={1}
        filter="drop-shadow(0 1px 3px rgba(0, 0, 0, 0.2))"
      />

      <text
        x={x} y={y1 + 3}
        className="text-xs font-bold fill-amber-800"
        textAnchor="middle"
        dominantBaseline="middle"
        transform={settings.ribaltaCentrale === 1 ? `rotate(180, ${x}, ${y1})` : ''}
      >
        {loopData.content}
      </text>
    </g>
  );
};

export default LoopMarking;

